import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './updatePaymentStyle.scss';

const BasicImage = (props) => {
  return <Image src={props.src} className={'' + (props.classname ? props.classname : '')} />;
};

export default BasicImage;
